import { createNamespacedHelpers } from 'vuex';

const { mapState } = createNamespacedHelpers('app/share');

const common = {
    data() {
        return {
            isLoading: false,
        };
    },
    beforeRouteEnter(to, from, next) {
        next(async (vm) => {
            if (!to.params.id) {
                to = { name: 'error', params: { status: 404 } };
            } else {
                if (!vm.hasItem) await vm.fetchData();
                if (vm.isSingleSetShare && to.name === 'home') {
                    // redirect for single collection shares
                    to = {
                        name: 'set-view',
                        params: { id: vm.item.id, set_id: vm.item.mediaSets[0].id },
                        query: vm.query,
                        replace: true,
                    };
                    next(to);
                }
            }
            next();
        });
    },
    computed: {
        ...mapState({
            item: (state) => state.item,
        }),
        hasItem() {
            return this.item && Object.keys(this.item).length > 0;
        },
        hasSets() {
            return this.hasItem && this.item.mediaSets.length > 0;
        },
        hasMedia() {
            return this.hasItem && this.item.mediaItems.length > 0;
        },
        routeName() {
            return this.$route.name;
        },
        isSingleSetShare() {
            return this.hasItem && !this.hasMedia && this.hasSets && this.item.mediaSets.length === 1;
        },
    },
    watch: {
        hasItem(newValue) {
            if (newValue) {
                document.title = `${this.item.title} | ${this.project.name} | ${this.client.name} | Powered by CA`;
            }
        },
    },
    methods: {
        async fetchData() {
            this.isLoading = true;

            try {
                const payload = { id: this.$route.params.id };

                if (this.$route.query.e) {
                    payload.email = this.$route.query.e;
                }

                const response = await this.$store.dispatch('app/share/fetchJSON', payload);
                await this.$store.dispatch('app/setData', response);
                this.isLoading = false;
                return response;
            } catch (error) {
                let status = 500;
                if (error.response && error.response.status) {
                    status = error.response.status;
                }

                if (status === 401) {
                    // auth required
                    await this.$store.dispatch('app/setClientProject', error.response.data);
                    this.$router.replace({
                        name: 'login',
                        params: { id: this.$route.params.id },
                        query: this.$route.query,
                    });
                } else {
                    this.$router.replace({ name: 'error', params: { id: this.$route.params.id, status } });
                    console.error(error);
                }

                return error;
            }
        },
    },
};

export default common;
